import ActionsForm from '@/shared/mixins/actionsForm'
import addquestion from './addquestion/addquestion.vue'
import qmaTemplate from '@/shared/http/repositories/business/qmaTemplate'
import deleteQuestion from '../deleteQuestion/deleteQuestion.vue'
import IconCampoPequeno from '../../../../../../../../../../static/img/qma/IconCampoPequeno.svg'
import IconData from '../../../../../../../../../../static/img/qma/IconData.svg'
import IconNumero from '../../../../../../../../../../static/img/qma/IconNumero.svg'
import IconSelecaoAnexo from '../../../../../../../../../../static/img/qma/IconSelecaoAnexo.svg'
import IconImagem from '../../../../../../../../../../static/img/qma/IconImagem.svg'
import IconCampoTexto from '../../../../../../../../../../static/img/qma/IconCampoTexto.svg'
import IconSelecaoTexto from '../../../../../../../../../../static/img/qma/IconSelecaoTexto.svg'
import IconAvaliacao from '../../../../../../../../../../static/img/qma/Icon_avaliacao.svg'
import IconDocs from '../../../../../../../../../../static/img/qma/IconDocs.svg'

import { toast } from '@/shared/utils/UIHelper'

export default {
  name: 'SubGroupDetail',
  props: ['templateid', 'preRequisito', 'dadosSubGrupo', 'grupoId', 'etapaCriada', 'metadado', 'equipamento'],
  components: {addquestion, deleteQuestion},
  mixins: [ActionsForm],
  data () {
    return {
      imgNumero: IconNumero,
      imgImagem: IconImagem,
      tipometadado: false,
      etapaGrupoSelecionadoId: null,
      imgAvaliacao: IconAvaliacao,
      imgDocs: IconDocs,
      imgSelecaoTexto: IconSelecaoTexto,
      imgCampoChecklist: IconCampoTexto,
      imgAnexo: IconSelecaoAnexo,
      imgTexto: IconCampoPequeno,
      openSections: [],
      imgData: IconData,
      edicaoPergunta: false,
      itensChecado: [],
      subGrupo: true,
      etapaId: null,
      pergunta: null,
      novaPergunta: [],
      perguntaId: null,
      changeAngel: false,
      openedCollapses: []
    }
  },
  watch: {
    dadosSubGrupo (value) {
      this.dadosSubGrupo = value
    }
  },
  methods: {
    abrirCollapse (id, tipoCampo, itensSelecao) {
      if (this.openedCollapses.includes(id)) {
        // Fechar colapso
        this.openedCollapses = this.openedCollapses.filter(collapseId => collapseId !== id)
      } else {
        // Abrir colapso
        this.openedCollapses.push(id)
      }
      if (tipoCampo === 4) {
        this.buscarImagemPergunta(itensSelecao, id)
      }
    },
    buscarImagemPergunta (itensSelecao, perguntaId) {
      for (let i = 0; i < itensSelecao.itensSelecaoImagem.length; i++) {
        qmaTemplate.DownloadPerguntaTemplate({urlImagem: itensSelecao.itensSelecaoImagem[i].urlImagem, perguntaSelecaoId: itensSelecao.itensSelecaoImagem[i].perguntaSelecaoImagemId, perguntaId: perguntaId})
          .then((Response) => {
            this.ResultTemplateQMA = Response.data
            this.colocaBase64(Response.data)
          })
          .catch((Error) => {
            toast.error('imagem não encontrada!')
          })
      }
    },
    colocaBase64 (value) {
      for (let i = 0; i < this.dadosSubGrupo[0].itens.length; i++) {
        if (this.dadosSubGrupo[0].itens[i].perguntaId === value.perguntaId) {
          for (let j = 0; j < this.dadosSubGrupo[0].itens[i].itensSelecaoImagem.length; j++) {
            if (this.dadosSubGrupo[0].itens[i].itensSelecaoImagem[j].perguntaSelecaoImagemId === value.perguntaSelecao) {
              this.dadosSubGrupo[0].itens[i].itensSelecaoImagem[j].base64 = value.base64
            }
          }
        }
      }
    },
    isOpen (id) {
      // Verifica se o colapso está aberto
      return this.openedCollapses.includes(id)
    },
    abrirModalPergunta (edicao, etapaId, pergunta, perguntaId, tipoCampo, adicao, itemImagem, multiplos, itens, metadado, data) {
      this.etapaGrupoSelecionadoId = data.etapaIdGrupoId
      if (tipoCampo === 4) {
        this.buscarImagemPergunta(itens, perguntaId)
      }
      this.tipometadado = metadado
      var opcional = null
      var nivel = null

      if (itens !== undefined && itens !== null) {
        // sempre no sentido do banco (true = NAO obrigatorio); quem inverte pra tela
        // e o popUptAddPergunta do addquestion.
        opcional = itens.opcional
        nivel = itens.nivelPrioridadePergunta
      }
      this.etapaId = etapaId
      if (edicao === true) {
        this.edicaoPergunta = true
        this.pergunta = pergunta
        this.perguntaId = perguntaId
      } else {
        this.edicaoPergunta = false
      }
      var proximoNivel = this.verUltimoNivelPrioridade(data)
      if (edicao === true) {
        proximoNivel = itens.nivelPrioridadePergunta
      }

      this.$refs.modalPerguntas[0].popUptAddPergunta(pergunta, tipoCampo, adicao, itemImagem, multiplos, opcional, nivel, proximoNivel, this.edicaoPergunta)
    },
    verUltimoNivelPrioridade (data) {
      if (data.itens.length === 0) {
        return 1.01 // Caso o formato dos dados seja inválido
      }
      // Encontrar o maior valor, ignorando valores null
      const maiorNivelPrioridade = data.itens.reduce((max, pergunta) => {
        const nivelAtual = parseFloat(pergunta.nivelPrioridadePergunta)// Converte para número
        return !isNaN(nivelAtual) && nivelAtual > max ? nivelAtual : max
      }, -Infinity)

      // Caso todos os valores sejam null, o maior nível será 1
      const nivelBase = maiorNivelPrioridade === -Infinity ? 1 : parseFloat(maiorNivelPrioridade)

      // Incrementar o maior valor
      const incremento = nivelBase % 1 === 0 ? 1 : 0.01 // Inteiros recebem 1, decimais recebem 0.01

      // Calcular o novo nível com arredondamento
      const novoNivelPrioridade = parseFloat((nivelBase + incremento).toFixed(2))
      return novoNivelPrioridade
    },
    abrirModalResposta () {
      this.$refs['addResposta'].show()
    },
    fecharPopUptAddResposta () {
      this.$refs['addResposta'].hide()
    },
    popUpExcluirEquipamento () {
      this.$refs.modal_Excluir[0].popUptAdd()
    },
    abrirModalExcluirPergunta () {
      this.$refs.modal_Excluir[0].popUptAdd()
    },
    abrirPopUpPreRequisitoButtoHeader (etapaId) {
      this.abrirModalPergunta(false, etapaId, null, null)
    },
    SelecionarPergunta (id, etapaId, acaoParaTodos) {
      this.Adicionar = !this.Adicionar
      var div = null

      div = document.getElementById(id.perguntaId)
      // Verifica se a classe 'clicked' já está presente na div
      var isClicked = div.classList.contains('clicked')
      // Se já estiver clicada, remove a classe, caso contrário, adiciona

      if (acaoParaTodos == null) {
        if (isClicked) {
          div.classList.remove('clicked')
          this.CheckItem(id.perguntaId, etapaId, false)
          this.itensChecado = this.itensChecado.filter(item => !(item.etapaId === etapaId && item.perguntaId === id.perguntaId))
        } else {
          div.classList.add('clicked')
          this.CheckItem(id.perguntaId, etapaId, true)
          if (this.itensChecado !== null && this.itensChecado !== undefined && this.itensChecado.length > 0) {
            let item = {
              etapaId: etapaId,
              perguntaId: id.perguntaId
            }
            this.itensChecado.push(item)
          } else {
            let item = {
              etapaId: etapaId,
              perguntaId: id.perguntaId
            }
            this.itensChecado[0] = item
          }
        }
      } else {
        if (acaoParaTodos === false) {
          div.classList.remove('clicked')
          this.CheckItem(id.perguntaId, etapaId, false)
          this.itensChecado = this.itensChecado.filter(item => !(item.etapaId === etapaId && item.perguntaId === id.perguntaId))
        } else {
          div.classList.add('clicked')
          this.CheckItem(id.perguntaId, etapaId, true)
          if (this.itensChecado !== null && this.itensChecado !== undefined && this.itensChecado.length > 0) {
            let item = {
              etapaId: etapaId,
              perguntaId: id.perguntaId
            }
            this.itensChecado.push(item)
          } else {
            let item = {
              etapaId: etapaId,
              perguntaId: id.perguntaId
            }
            this.itensChecado[0] = item
          }
        }
      }
    },

    SelecionarEtapa (etapaId) {
      this.Adicionar = !this.Adicionar

      var div = null

      div = document.getElementById(etapaId)

      // Verifica se a classe 'clicked' já está presente na div
      var isClicked = div.classList.contains('clicked')
      // Se já estiver clicada, remove a classe, caso contrário, adiciona
      if (isClicked) {
        div.classList.remove('clicked')
        this.CheckTodosItem(etapaId, false)
      } else {
        div.classList.add('clicked')
        this.CheckTodosItem(etapaId, true)
      }
    },

    CheckItem (id, etapaId, value) {
      for (let i = 0; i < this.dadosSubGrupo.length; i++) {
        if (this.dadosSubGrupo[i].etapaId === etapaId) {
          for (let j = 0; j < this.dadosSubGrupo[i].itens.length; j++) {
            if (this.dadosSubGrupo[i].itens[j].perguntaId === id) {
              this.dadosSubGrupo[i].itens[j].check = value
            }
          }
        }
      }
    },
    CheckTodosItem (etapaId, value) {
      for (let i = 0; i < this.dadosSubGrupo.length; i++) {
        if (this.dadosSubGrupo[i].etapaId === etapaId) {
          this.dadosSubGrupo[i].checkTodosItens = value
          for (let j = 0; j < this.dadosSubGrupo[i].itens.length; j++) {
            this.SelecionarPergunta(this.dadosSubGrupo[i].itens[j], etapaId, value)
          }
        }
      }
    },
    temItenschecado () {
      if (this.itensChecado.length > 0) {
        return true
      } else {
        return false
      }
    },
    deleteItensSubGrupo () {
      if (this.itensChecado.length > 0) {
        // Criar um array temporário para armazenar os itens que precisam ser removidos
        let itensARemover = []

        for (let i = 0; i < this.itensChecado.length; i++) {
          for (let j = 0; j < this.dadosSubGrupo.length; j++) {
            if (this.dadosSubGrupo[j].etapaId === this.itensChecado[i].etapaId) {
              this.dadosSubGrupo[j].edicao = true
              this.dadosSubGrupo[j].descricaoEdicao = 'AG. ENVIO ITEM ALTERADO'
              this.dadosSubGrupo[j].colorStatus = 'rgb(255, 216, 187)'
              this.dadosSubGrupo[j].colorFonte = 'rgb(188, 72, 7)'
              for (let e = 0; e < this.dadosSubGrupo[j].itens.length; e++) {
                if (this.dadosSubGrupo[j].itens[e].perguntaId === this.itensChecado[i].perguntaId) {
                  this.dadosSubGrupo[j].itens[e].check = false
                  this.dadosSubGrupo[j].itens[e].edicao = true
                  this.dadosSubGrupo[j].itens[e].descricaoEdicao = 'AG. ENVIO EXCLUSÃO'
                  this.dadosSubGrupo[j].itens[e].colorStatus = 'rgb(255, 205, 205)'
                  this.dadosSubGrupo[j].itens[e].colorFonte = 'rgb(136, 22, 22)'
                  this.dadosSubGrupo[j].itens[e].exclusao = true

                  let div = document.getElementById(this.itensChecado[i].perguntaId)
                  var isClicked = div.classList.contains('clicked')
                  if (isClicked) {
                    div.classList.remove('clicked')
                  }

                  toast.info('Sucesso! Ag. Envio da Exclusão')
                  // Adicionar o item ao array de remoção
                  itensARemover.push(this.itensChecado[i])

                  let value = {
                    perguntaId: this.itensChecado[i].perguntaId,
                    etapaId: this.itensChecado[i].etapaId
                  }

                  this.$emit('ExcluirPerguntaPreRequisito', value)
                  this.$emit('ExcluirPerguntaEquipamento', value)
                  this.$emit('ExcluirPerguntaTemplate', value)
                }
              }
            }
            this.dadosSubGrupo[j].checkTodosItens = false

            let div = document.getElementById(this.itensChecado[i].etapaId)
            isClicked = div.classList.contains('clicked')

            if (isClicked) {
              div.classList.remove('clicked')
            }
          }
        }
        // Remover os itens fora do loop principal
        this.itensChecado = this.itensChecado.filter(item => !itensARemover.includes(item))
      } else {
        toast.warning('Não há itens selecionados para exclusão')
      }
    },
    RemoverEdicao (etapaId, perguntaId) {
      let value = {
        etapaId: etapaId,
        perguntaId: perguntaId,
        grupoId: this.grupoId
      }
      for (let j = 0; j < this.dadosSubGrupo.length; j++) {
        if (this.dadosSubGrupo[j].etapaId === etapaId) {
          for (let e = 0; e < this.dadosSubGrupo[j].itens.length; e++) {
            this.dadosSubGrupo[j].edicao = false
            this.dadosSubGrupo[j].descricaoEdicao = ''
            this.dadosSubGrupo[j].colorStatus = ''
            this.dadosSubGrupo[j].colorFonte = ''
            if (this.dadosSubGrupo[j].itens[e].perguntaId === perguntaId && this.dadosSubGrupo[j].itens[e].adicao === false) {
              this.dadosSubGrupo[j].itens[e].exclusao = false
              this.dadosSubGrupo[j].itens[e].edicao = false
              this.dadosSubGrupo[j].itens[e].descricaoEdicao = ''
              this.dadosSubGrupo[j].itens[e].colorStatus = ''
              this.dadosSubGrupo[j].itens[e].colorFonte = ''
              toast.success('Edição removida com sucesso!')
              this.$emit('RemoverExclusaoPerguntaPreRequisito', value)
              this.$emit('RemoverEdicaoExcluirPerguntaEquipamento', value)
              this.$emit('RemoverEdicaoExcluirPerguntaTemplate', value)
            }

            if (this.dadosSubGrupo[j].itens[e].perguntaId === perguntaId && this.dadosSubGrupo[j].itens[e].adicao === true) {
              // Remover o item da lista
              this.dadosSubGrupo[j].itens.splice(e, 1)
              toast.success('item removido com sucesso!')
              e--
              this.$emit('ExcluirNovaPerguntaPreRequisito', value)
              this.$emit('ExcluirPerguntaPerguntaEquipamentoCriado', value)
              this.$emit('ExcluirPerguntaTemplateDetalheCriado', value)
              this.$emit('ExcluirPerguntaTemplateDetalheSubEtapa', value)
              this.$emit('ExcluirPerguntaTemplateDetalheEtapa', value)
            }
          }
        }
      }
    },
    tabelaNovaPergunta (value) {
      for (let j = 0; j < this.dadosSubGrupo.length; j++) {
        if (this.dadosSubGrupo[j].etapaId === value.etapaId) {
          // Adiciona o objeto 'value.pergunta' inteiro no array 'itens'
          this.dadosSubGrupo[j].itens.push(value.pergunta)
          break // Saímos do loop se já encontramos a etapaId
        }
      }
    },
    addNovaPerguntaEtapaSubCriada (value) {
      this.$emit('addNovaPerguntaEtapaSubCriada', value)
    },
    addNovaPerguntaParaSubEtapa (value) {
      this.$emit('addNovaPerguntaParaSubEtapa', value)
    },
    addNovaPergunta (value) {
      this.$emit('NovaPerguntaPreRequisito', value)
    },
    addNovaPerguntaGrupo (value) {
      this.$emit('NovaPerguntaGrupo', value)
    },
    addNovaPerguntaImagem (value) {
      this.$emit('addNovaPerguntaImagem', value)
    },
    EditarNovaPerguntaImagem (value) {
      this.$emit('EditarNovaPerguntaImagem', value)
    },
    editarNovaPerguntaEtapaSubCriada (value) {
      this.$emit('editarEmMemoriaNovaPerguntaEtapaSubCriada', value)
    },
    editarNovaPerguntaParaSubEtapa (value) {
      this.$emit('editarEmMemoriaNovaPerguntaParaSubEtapa', value)
    },
    editarEmMemoriaNovaPerguntaParaEtapa (value) {
      this.$emit('editarEmMemoriaNovaPerguntaParaEtapa', value)
    },
    removerImagemNova (value) {
      this.$emit('removerImagemNova', value)
    },
    editarPergunta (value) {
      for (let j = 0; j < this.dadosSubGrupo.length; j++) {
        if (this.dadosSubGrupo[j].etapaId === value.etapaId) {
          for (let e = 0; e < this.dadosSubGrupo[j].itens.length; e++) {
            if (this.dadosSubGrupo[j].itens[e].perguntaId === value.perguntaId && this.dadosSubGrupo[j].itens[e].adicao === false) {
              this.dadosSubGrupo[j].itens[e].edicao = false
              this.dadosSubGrupo[j].itens[e].descricaoEdicao = 'AG. ENVIO EDIÇÃO'
              this.dadosSubGrupo[j].itens[e].colorStatus = 'rgb(255, 216, 187)'
              this.dadosSubGrupo[j].itens[e].colorFonte = 'rgb(188, 72, 7)'
              this.dadosSubGrupo[j].itens[e].edicao = true
              this.dadosSubGrupo[j].itens[e].descricaoPergunta = value.pergunta
              this.dadosSubGrupo[j].itens[e].nivelPrioridadePergunta = value.nivelPrioridadePergunta
              this.$emit('EditaPreRequisitoPergunta', value)
              this.$emit('EditaEquipamentoPergunta', value)
              this.$emit('EditaTemplatePergunta', value)
              toast.info('Sucesso! Ag. Envio Edição')
            }
            if (this.dadosSubGrupo[j].itens[e].perguntaId === value.perguntaId && this.dadosSubGrupo[j].itens[e].adicao === true) {
              this.dadosSubGrupo[j].itens[e].descricaoPergunta = value.pergunta
              this.dadosSubGrupo[j].itens[e].nivelPrioridadePergunta = value.nivelPrioridadePergunta
              this.dadosSubGrupo[j].itens[e].opcional = value.opcional
              this.dadosSubGrupo[j].itens[e].multiplos = value.multiplos
              this.dadosSubGrupo[j].itens[e].tipoCampo = value.tipoCampo
              this.$emit('EditaPreRequisitoNovaPergunta', value)
              this.$emit('EditaEquipamentoNovaPergunta', value)
              this.$emit('EditaTemplateNovaPergunta', value)

              toast.info('Sucesso! Ag. Envio Novo Item')
            }
          }
        }
      }
    },
    excluirImagem (value) {
      for (let j = 0; j < this.dadosSubGrupo.length; j++) {
        if (this.dadosSubGrupo[j].etapaId === value.etapaId) {
          for (let e = 0; e < this.dadosSubGrupo[j].itens.length; e++) {
            if (this.dadosSubGrupo[j].itens[e].perguntaId === value.perguntaId && this.dadosSubGrupo[j].itens[e].adicao === false) {
              for (let p = 0; p < this.dadosSubGrupo[j].itens[e].itensSelecaoImagem.length; p++) {
                if (this.dadosSubGrupo[j].itens[e].itensSelecaoImagem[p].adicao === false && this.dadosSubGrupo[j].itens[e].itensSelecaoImagem[p].perguntaSelecaoImagemId === value.perguntaSelecaoImagemId) {
                  this.dadosSubGrupo[j].itens[e].itensSelecaoImagem[p].exclusao = true
                }
              }
            }
          }
        }
      }
    },
    editarImagemNova (value) {
      for (let j = 0; j < this.dadosSubGrupo.length; j++) {
        if (this.dadosSubGrupo[j].etapaId === value.etapaId) {
          for (let e = 0; e < this.dadosSubGrupo[j].itens.length; e++) {
            if (this.dadosSubGrupo[j].itens[e].perguntaId === value.perguntaId && this.dadosSubGrupo[j].itens[e].adicao === false) {
              for (let p = 0; p < this.dadosSubGrupo[j].itens[e].itensSelecaoImagem.length; p++) {
                if (this.dadosSubGrupo[j].itens[e].itensSelecaoImagem[p].adicao === false && this.dadosSubGrupo[j].itens[e].itensSelecaoImagem[p].perguntaSelecaoImagemId === value.perguntaSelecaoImagemId) {
                  this.dadosSubGrupo[j].itens[e].itensSelecaoImagem[p].exclusao = true
                }
              }
            }
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/TemplateDetail/SubGroupDetail/SubGroupDetail.js